module.exports = __webpack_public_path__ + "img/zhiditu@2x.16b46329.png";